import { Box, Dialog, IconButton, Tooltip, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ExoForm from '../../ExoForm';
import DateTimeLabel from '../../../label/DateTimeLabel';
import MoreTimeIcon from '@mui/icons-material/MoreTime';
import { API_PATCH, DBRequest, useConfig } from '../../../../api/api';
import { ProjectUserStack } from '../ProjectUserStack';
import { useEffect, useRef, useState } from 'react';
import * as Yup from 'yup';
import ExoDialog from '../../ExoDialog';

const WPEToDoElementPopup = ({
  element,
  open,
  onClose,
  onResponse,
  onDelete,
  wpeId,
  pid,
}) => {
  const { t } = useTranslation();

  const config = useConfig();

  const popupRef = useRef();

  const [users, setUsers] = useState(element.users);

  const validationSchema = Yup.object({
    name: Yup.string().required('Name is required'),
  });

  const fields = [
    { label: t('Title'), key: 'name', type: 'text' },
    { label: t('Description'), key: 'description', type: 'richTextEditor' },
    {
      label: t('Priority'),
      key: 'priority',
      type: 'customSelect',
      options: [
        //{ label: t("Default"), value: 0 },
        { label: t('Low'), value: 1 },
        { label: t('Medium'), value: 2 },
        { label: t('High'), value: 3 },
      ],
    },
    { label: t('Deadline'), key: 'deadline', type: 'date' },
    {
      label: t('Points'),
      key: 'effortScore',
      type: 'number',
      decimalPlaces: 0,
      unformatted: true,
    },
    {
      label: t('Links'),
      key: 'externalResources',
      type: 'nameValueArray',
      addLabel: t('Add link'),
      nameKey: 'label',
      valueKey: 'url',
      radioItems: [], // no radio selection for links
      placeholder: {
        name: t('Label'),
        value: t('Link'),
      },
    },
    // multiple files
    {
      label: t('Files'),
      key: 'files',
      type: 'attachments',
      maxItems: 10,
      mediaType: 'PRIVATE',
    },
  ];

  function handleSubmit() {
    let newTask = popupRef.current.dataCollection;
    newTask = { ...newTask, priority: newTask.priority ? newTask.priority : 0 };
    DBRequest({
      config,
      path: `work-packages/elements/list/tasks/${element.id}`,
      method: API_PATCH({ ...newTask, users: users }),
      onResponse: handleResponse,
    });
  }

  function handleResponse(data) {
    onResponse(data);
    onClose();
  }

  function handleMemberChange(newMembers) {
    setUsers(newMembers.users);
  }

  return (
    <ExoDialog className="relative" open={open} onClose={onClose} limitWidth>
      <Box className="w-full mb-3 relative">
        <Box className="flex flex-col md:flex-row items-start md:items-center md:justify-between">
          <Box>
            <Typography variant="h3">{t('Edit Task')}</Typography>
            <Tooltip
              title={t('Date created')}
              className="flex gap-1 items-center my-2"
            >
              <MoreTimeIcon fontSize="small" />
              <Typography variant="h6">
                <DateTimeLabel dateTime={element.createdAt} />
              </Typography>
            </Tooltip>
          </Box>
          <ProjectUserStack
            changeApi={`tasks/${element.id}/members`}
            editmode={true}
            users={users || []}
            //api={"users"}
            projectId={pid}
            onChange={handleMemberChange}
            noLabel={true}
          />
        </Box>
        <ExoForm
          ref={popupRef}
          fields={fields}
          startDataCollection={element}
          onSubmit={handleSubmit}
          validationSchema={validationSchema}
          onCancel={onClose}
        />
      </Box>
    </ExoDialog>
  );
};

export default WPEToDoElementPopup;
